<template>
  <div>
    <a-card title="生产报表">
      <a-row :gutter="[12, 8]">
        <a-col :span="24" style="width: 256px">
          <a-range-picker @change="onChangePicker" />
        </a-col>
        <a-col :span="24" style="width: 240px">
          <a-input v-model="searchForm.search" placeholder="生产工单号" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 240px">
          <a-input v-model="searchForm.goods_search" allowClear placeholder="物料编号, 名称" @pressEnter="search" />
        </a-col>

        <a-col :span="24" style="width: 240px">
          <ProcessSelect v-model="searchForm.process" allowClear placeholder="工序" @change="search" />
        </a-col>
        <a-col :span="24" style="width: 240px">
          <UserSelect v-model="searchForm.handler" allowClear placeholder="报工人" @change="search" />
        </a-col>

        <a-col :span="24" style="width: 94px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
        <a-col :span="24" style="width: 94px">
          <a-button-group>
            <a-button icon="download" @click="exportExcel">导出</a-button>
          </a-button-group>
        </a-col>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table
          rowKey="id"
          size="small"
          :columns="columns"
          :data-source="items"
          :pagination="pagination"
          :scroll="{ x: true }"
          :loading="loading"
          @change="tableChange"
        >
          <div slot="production_order_number" slot-scope="value, item">
            <a @click="jumpProductionOrderDetailPage(item)">{{ value }}</a>
          </div>
        </a-table>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { productionRecordExport, productionRecordList } from "@/api/production";
import { exportExcel } from "@/utils/excel";

export default {
  components: {
    ProcessSelect: () => import("@/components/ProcessSelect"),
    UserSelect: () => import("@/components/UserSelect"),
  },
  data() {
    return {
      searchForm: { search: "", page: 1, ordering: undefined },
      pagination: { current: 1, total: 0, pageSize: 10 },
      loading: false,
      items: [],
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          width: 60,
          fixed: "left",
          customRender: (value, item, index) => {
            return index + 1;
          },
        },
        {
          title: "生产工单号",
          dataIndex: "production_order_number",
          width: 160,
          fixed: "left",
          scopedSlots: { customRender: "production_order_number" },
        },
        {
          title: "公司订单号",
          dataIndex: "company_order_number",
        },
        {
          title: "项目分段",
          dataIndex: "project_code",
        },
        {
          title: "工作中心",
          dataIndex: "workstation_name",
        },
        {
          title: "工序",
          dataIndex: "process_name",
        },
        {
          title: "物料名称",
          dataIndex: "goods_name",
        },
        {
          title: "物料编号",
          dataIndex: "goods_number",
        },
        {
          title: "物料规格",
          dataIndex: "goods_spec",
        },
        {
          title: "物料单重(kg)",
          dataIndex: "goods_weight",
        },
        {
          title: "原图材质",
          dataIndex: "original_texture",
        },
        {
          title: "替代材质",
          dataIndex: "substitute_texture",
        },
        {
          title: "生产数量",
          dataIndex: "production_quantity",
          width: 100,
        },
        {
          title: "报工人",
          dataIndex: "handler_name",
          width: 180,
        },
        {
          title: "开始时间",
          dataIndex: "start_time",
          width: 180,
        },
        {
          title: "结束时间",
          dataIndex: "end_time",
          width: 180,
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180,
        },
        {
          title: "创建人",
          dataIndex: "creator_name",
          width: 180,
        },
      ],
    };
  },
  methods: {
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      productionRecordList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.results;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create() {
      this.list();
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      if (sorter.field) {
        this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      }
      this.list();
    },
    exportExcel() {
      productionRecordExport(this.searchForm)
        .then((resp) => {
          exportExcel(resp, "生产报表");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    onChangePicker(date, dateString) {
      let startDate = date[0];
      let endDate = date[1];
      this.searchForm.start_date = startDate ? startDate.format("YYYY-MM-DD") : undefined;
      this.searchForm.end_date = endDate ? endDate.add(1, "days").format("YYYY-MM-DD") : undefined;
      this.search();
    },
    jumpProductionOrderDetailPage(item) {
      this.$router.push({ path: "/production/detial", query: { id: item.production_order } });
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style scoped></style>
